import React, { useState, useEffect } from 'react';
import ContestDetailDialog from '../contests/detail-component';
import { useLocation, useParams } from 'react-router-dom';
import { ContestDetail } from '../../types';
import createAxiosInstance from '../../api/axiosConfig';
import { CONTEST_BY_ID } from '../../api/endpoint';

const ContestDetailPage = () => {
  const location = useLocation();
  const { contest, timeline } = location.state || {};
  const { contestId } = useParams();
  const [contestDetail, setContestDetail] = useState<ContestDetail | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(timeline);

  const fetchContestDetail = async () => {
    if (!contestId) return;
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${CONTEST_BY_ID}${contestId}`);
      setContestDetail(response.data.data[0]);
      setType(response.data.data[0].state);
      setDialogOpen(true);
    } catch (error) {
      console.error('Error fetching contest details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (contest) {
      setContestDetail(contest);
      setDialogOpen(true);
    } else {
      fetchContestDetail();
    }
  }, [contest, contestId]);

  return (
    <div>
      {contestDetail && (
        <ContestDetailDialog
          open={dialogOpen}
          contestDetail={contestDetail}
          setDialogOpen={setDialogOpen}
          timeline={type}
        />
      )}
    </div>
  );
};

export default ContestDetailPage;
